import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Lenis from "lenis";

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
